<template>
  <div class="public-content recharge-enquiry">
    <div class="breadcrumb">售后问题类型管理</div>
    <div class="right-main">
      <!--   查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="5">
            <el-form-item label="关键词:">
              <el-input v-model="formInline.orderNo" placeholder="" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="onSubmit" round>查询</el-button>
            <el-button class="search-ok" @click="applyRecharge" round type="primary">新建问题类型</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%">
          <el-table-column label="问题类型" prop="orderNo" min-width="10px">
          </el-table-column>
          <el-table-column prop="note" label="是否启用" min-width="10">
          </el-table-column>
          <el-table-column label="操作" min-width="10px">
            <template v-slot="scope">
              <span class="color-blue" @click="getOrderStatus()">{{ scope.row.auditStatus }}<br></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页-->
      <v-pagination class="v-pagination" :queryInfo='queryInfo'></v-pagination>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index.vue'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index.vue'
import { chargePage, chargeStatsPage, tradePage } from '@/api/epay'
import { storeQueryListByCode, getSalesmanByFullName } from '@/api/crm'
export default {
  name: 'recharge-enquiry',
  components: {
    VPagination,
    CombinedDialog
  },
  data () {
    return {
      code: '',
      fullName: '',
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      formInline: {
        auditStatus: null,
        dateEnd: null,
        dateStart: null,
        id: null,
        orderNo: null,
        salesmanId: null,
        storeId: null,
        tradeMethod: null
      },
      tableData: [],
      btnName: '申请充值',
      value2: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      gridData: [{
        date: '2016-05-02',
        remark: 'scsf',
        name: '王小虎',
        address: '上海'
      }],
      systemType: JSON.parse(window.localStorage.getItem('key'))
    }
  },
  watch: {
    value2 () {
      this.formInline.dateStart = this.$moment(this.value2[0]).format('YYYY-MM-DD')
      this.formInline.dateEnd = this.$moment(this.value2[1]).format('YYYY-MM-DD')
    },
    systemType () {
      this.systemType = JSON.parse(window.localStorage.getItem('key'))
    }
  },
  created () {
    if (this.systemType === 0 || this.systemType === 1) {
      this.btnName = '申请充值'
    }
    if (this.systemType === 2) {
      this.btnName = '充值'
    }
    this.onSubmit()
    // chargeStatsPage()
  },
  methods: {
    onSubmit () {
      // 向后台发送post请求,获取查询数据存储在tableData
      chargePage({ data: this.formInline, params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize } }).then(res => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.content
          this.tableData.forEach(item => {
            if (item.auditStatus === 'AUDITED') {
              this.$set(item, 'auditStatus', '已审核')
            } else if (item.auditStatus === 'APPLY') {
              this.$set(item, 'auditStatus', '未审核')
            } else if (item.auditStatus === 'REJECTED') {
              this.$set(item, 'auditStatus', '拒绝')
            } else if (item.auditStatus === 'CANCELLED') {
              this.$set(item, 'auditStatus', '取消')
            }
            if (item.tradeMethod === 'CHARGE_ONLINE') {
              this.$set(item, 'tradeMethod', '线上充值')
            } else if (item.tradeMethod === 'CHARGE_OFFLINE') {
              this.$set(item, 'tradeMethod', '离线充值')
            } else if (item.tradeMethod === 'CHARGE_ORDER_CANCELLED') {
              this.$set(item, 'tradeMethod', '负责订单取消')
            } else if (item.tradeMethod === 'CHARGE_REFUND_POSTSALE') {
              this.$set(item, 'tradeMethod', '负责退款良好')
            }
          })
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    goPath (row) {
      this.$router.push({
        path: './epay/vpayChargeDetail',
        query: {
          id: row.id,
          auditStatus: row.auditStatus
        }
      })
    },
    getOrderStatus (value, index) {
      if (value === '编辑') {
        this.$router.push('/epay/vpayChargeApply')
      }
      if (value === '已审核') {
        this.$refs.dialogRef.show('status', '审核日志', this.tableData[index].gridData, '', '', 'checkLog')
      }
      if (value === '待审核' && this.systemType === 0) {
        this.$refs.dialogRef.show('status', '审核日志', this.tableData[index].gridData, '', '', 'checkLog')
      }
      if (value === '待审核' && this.systemType === 1) {
        this.$router.push({
          path: './epay/vpayChargeDetail',
          query: {
            id: 2
          }
        })
      }
      if (value === '待审核' && this.systemType === 2) {
        this.$router.push({
          path: './epay/vpayChargeDetail',
          query: {
            id: 0
          }
        })
      }
    },
    applyRecharge () {
      if (this.btnName === '申请充值') {
        this.$router.push('/epay/vpayChargeApply')
      }
      if (this.btnName === '充值') {
        this.$router.push('./platformrecharge')
      }
    },
    handleSelect (item) {
      this.formInline.storeId = item.id
    },
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    selectFullName (item) {
      this.formInline.salesmanId = item.id
    },
    queryFullNameAsync (queryString, cb) {
      // 改成业务的模糊查询
      getSalesmanByFullName(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.fullName
        })
        cb(res.data.data)
      })
    }
  }
}
</script>
 <style scoped lang="less">
 @deep: ~">>>";
 </style>
